import Vue from "vue";
import VueRouter from "vue-router";
import goTo from "vuetify/es5/services/goto";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Nucleo central",
    meta: {
      title: "Smile Magazine",
    },
    component: () => import("../pages/home/Home.vue"),
  },
  {
    path: "/blog/categoria/:categoria",
    name: "Blog by category",
    meta: {
      title: "Blog",
    },
    component: () => import("../pages/blog/PostsCategorized.vue"),
    props: (route) => ({ category: route.query.category })
  },
  {
    path: "/blog/:slug",
    name: "Article",
    meta: {
      title: "Article",
    },
    component: () => import("../pages/blog/PostDetails.vue"),
    props: (route) => ({ category: route.query.category })
  },
  {
    path: "/comunicacion",
    name: "Portfolio",
    meta: {
      title: "Portfolio",
    },
    component: () => import("../pages/portfolio/Portfolio.vue")
  },
  {
    path: "/equipo",
    name: "Equipo",
    meta: {
      title: "Equipo",
    },
    component: () => import("../pages/team/Team.vue")
  },
  {
    path: "/contacto",
    name: "Contacto",
    meta: {
      title: "Contacto",
    },
    component: () => import("../pages/contact/Contact.vue"),
  },
  {
    path: "*",
    name: "404",
    meta: {
      title: "Not Found",
    },
    component: () => import("../pages/404/404.vue")
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
  scrollBehavior: (to, from, savedPosition) => {
    let scrollTo = 0;

    if (to.hash) {
      scrollTo = to.hash;
    } else if (savedPosition) {
      scrollTo = savedPosition.y;
    }

    return goTo(scrollTo);
  },
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title;
  next();
});

export default router;
